// src/app/shared/services/swal.service.ts
import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalService {
  private isSwalOpen = false;

  constructor() {}

  async showTimerAlert(options: {
    title: string;
    html: string;
    timerSeconds: number;
    confirmButtonText?: string;
    cancelButtonText?: string;
    allowOutsideClick?: boolean;
  }): Promise<any> {
    if (this.isSwalOpen) return; // ❌ Don't open if already open

    this.isSwalOpen = true;
    let timerInterval: any;
    const timerMs = options.timerSeconds * 1000;

    return Swal.fire({
      title: options.title,
      html: options.html,
      timer: timerMs,
      timerProgressBar: true,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: options.confirmButtonText || 'Confirm',
      cancelButtonText: options.cancelButtonText || 'Cancel',
      allowOutsideClick: options.allowOutsideClick ?? false,
      didOpen: () => {
        const strongEl = Swal.getHtmlContainer()?.querySelector('strong');
        if (strongEl) {
          strongEl.style.color = '#DB1E49';
          strongEl.style.fontSize = '20px';
          strongEl.style.fontWeight = 'bold';
          timerInterval = setInterval(() => {
            const timeLeftMs:any = Swal.getTimerLeft();
            if (timeLeftMs !== null) {
              strongEl.textContent = Math.ceil(timeLeftMs / 1000).toString();
            }
          }, 1000);
        }
      },
      willClose: () => {
        clearInterval(timerInterval);
        this.isSwalOpen = false;
      }
    });
  }
}
